export type TNativeOfflineAudioContextConstructor = typeof OfflineAudioContext;
